export const _SUCCESS = "_SUCCESS";
export const _FAILURE = "_FAILURE";
export const FETCH_COMMENTS_DOCTORS_LIST_REQUEST = "FETCH_COMMENTS_DOCTORS_LIST_REQUEST";
export const FETCH_COMMENT_DOCTOR_REQUEST = "FETCH_COMMENT_DOCTOR_REQUEST";
export const UPDATE_COMMENT_DOCTOR_STATUS_REQUEST = "UPDATE_COMMENT_DOCTOR_STATUS_REQUEST";
export const ADD_FILTER_VALUES_FOR_COMMENTS_DOCTORS = "ADD_FILTER_VALUES_FOR_COMMENTS_DOCTORS";
